import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { Subject } from 'rxjs';

type State = { state: 'idle' | 'invalid' } | { state: 'valid'; data: any };

const initialState: State = { state: 'idle' };

@Injectable()
export class ApplicantDeclarationStore extends ComponentStore<State> {
  readonly setStateInvalid = this.updater(() => ({ state: 'invalid' }));
  readonly setDataValid = this.updater<any>((_, data) => ({ state: 'valid', data }));
  readonly dataState$ = this.select(s => (s.state === 'valid' ? s : null));
  readonly submit$ = new Subject<void>();

  constructor() {
    super(initialState);
  }
}
